module.exports = __webpack_public_path__ + "static/media/fog-low.1c4d39bd.png";